import { useMutation, useQueryClient } from '@tanstack/react-query';
import { http } from '@/shared/lib/api';
import { useTenantProfile, tenantProfileKey } from '@/modules/settings/tenant-profile/hooks/use-tenant-profile';

export interface TenantFeatures {
  companies: boolean;
  persons: boolean;
}

const DEFAULTS: TenantFeatures = { companies: true, persons: true };

export function useTenantFeatures(): TenantFeatures {
  const profile = useTenantProfile();
  const features = profile.data?.data?.features;
  if (!features) return DEFAULTS;
  return {
    companies: features.companies !== false,
    persons: features.persons !== false,
  };
}

interface FeaturesEnvelope {
  success: true;
  data: { features: TenantFeatures };
}

export function useUpdateTenantFeatures() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (patch: Partial<TenantFeatures>) =>
      http.patch<FeaturesEnvelope>('/api/tenant/profile/features', patch).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: tenantProfileKey }),
  });
}
